<template>
    <main id="mainCtrl">
        <SuccessModal ref="dialog"
                      :title="'Выгрузка ' + (M.uploadYandexFeedOn? 'включена' : 'отключена')"
                      :message="
                    'Выгрузка ваших врачей в Яндекс ' + (M.uploadYandexFeedOn? 'включена' : 'отключена') + '. Изменения<br/>' +
                    'вступят в силу после обработки данных Яндексом. <br/>' +
                    'Обычно это происходит в течение 7 дней.'"
        />
        <div class="promo">
            <div class="promo__data">
                <div class="promo__title">Выгрузка врачей в Яндекс</div>
                <div class="promo__markers">
                    <div class="promo__marker promo__marker_red">
                        Интеграция с Яндекс
                    </div>
                </div>
                <div class="promo__text">
                    <p>
                        Включите интеграцию с Яндекс, чтобы настроить выгрузку врачей и кнопку записи на прием через наш
                        сайт.
                    </p>
                    <ul>
                        <li>Выгрузка врачей в поиск Яндекса</li>
                        <li>Кнопка записи на прием через ДОКТУ</li>
                        <li>Автоматическое обновление информации</li>
                    </ul>
                </div>
                <div class="promo__actions">
                    <a href="#" @click="update" class="promo__btn" :class="{'promo__btn_red':M.uploadYandexFeedOn}">{{M.uploadYandexFeedOn?'Отключить':'Включить'}}</a>
                </div>
            </div>
            <div class="promo__img">
                <img src="/img/ya01.svg" alt="" />
            </div>
        </div>
    </main>
</template>
<script>
import SuccessModal from '@dialogs/SuccessModal.vue'

export default {
    components:{
        SuccessModal
    },
    props:{
        uploadYandexFeedOn:{default: false},
    },
    data(){
        return{
            M:{
                uploadYandexFeedOn: this.uploadYandexFeedOn
            },
        }
    },
    methods: {
        update(){
            this.M.uploadYandexFeedOn = !this.M.uploadYandexFeedOn;

            return this.axios.post('upload-yandex-feed/update', this.M).then(() => {
                this.$refs.dialog.show()
            });
        },
    },
}
</script>
